export default __webpack_public_path__ + "static/media/idSVG.6250234c.svg";